module.exports = __webpack_public_path__ + "img/Presenter-Black.23642c4f.png";